import type { Icon } from '../../../src/lib/types'
export const mdiMenuDown: Icon = {
  "id": "menu-down",
  "name": "Menu Down",
  "path": "M7,10L12,15L17,10H7Z",
  "as": [
    "arrow-drop-down",
    "caret-down"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiMenuDown